<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>
        {{ $t('detailFacture.commentaire.title')}}
      </p>
    </header>
    <div class="card-content">
      <div>
        <span class="has-text-weight-bold">
        {{ $t('detailFacture.commentaire.commentaireRelance')}}
        </span>
        <br>
        <span class="has-text-default is-italic has-text-weight-light">
            {{ commentaireRelance }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    commentaireRelance: {
      type: String,
      required: false,
    },
  },
};

</script>
